class elements {
  constructor(
    id,
    element,
    from,
    to,
    tolEnt,
    tolSal,
    conceptId,
    conceptName,
    laboral,
    aplFeriados,
    aplNoFeriados,
    mts,
    fracRed,
    porcen,
    resto
  ) {
    function hours(param) {
      let horas = Math.floor(param / 60);
      let min = Math.floor(horas * 60);
      min = param - min;
      if (horas < 10) {
        horas = "0" + horas;
      }
      min = min < 10 ? "0" + min : min;
      return horas + ":" + min;
    }
    this.id = id;
    this.name = element;
    this.from = hours(from);
    this.to = hours(to);
    this.tolEnt = hours(tolEnt);
    this.tolSal = hours(tolSal);
    this.conceptId = conceptId;
    this.conceptName = conceptName;
    this.laboral = laboral === true ? "✔️" : "";
    this.aplFeriados = aplFeriados;
    this.aplNoFeriados = aplNoFeriados;
    this.mts = hours(mts);
    this.fracRed = fracRed;
    this.porcen = porcen;
    this.resto = resto;
  }
  static fromJson({
    elemId,
    nomElem,
    desde,
    hasta,
    tolEnt,
    tolSal,
    conceptoId,
    nomConcepto,
    laboral,
    aplFeriados,
    aplNoFeriados,
    mts,
    fracRed,
    porcen,
    resto,
  }) {
    return new elements(
      elemId,
      nomElem,
      desde,
      hasta,
      tolEnt,
      tolSal,
      conceptoId,
      nomConcepto,
      laboral,
      aplFeriados,
      aplNoFeriados,
      mts,
      fracRed,
      porcen,
      resto
    );
  }
}
export default elements;
